<template>
    <transition enter-active-class="animate__animated animate__fadeInUp" leave-active-class="animate__animated animate__fadeOutDown" class="tran" mode="out-in">
        <div v-if="show" class="fixed bgcolor" :class="{ios:isios==true}" @click="onclickmask()">
            <div class="picker-list" :style="liststyle">
                <div class="header">
                    <div class="close-tap">
                        <span @click="show=false;">X</span>
                    </div>
                </div>

                <wxl-search-box ref="searchbox" class="search-box" :caption="title" style="z-index:999" :isabsolute="true" @search="onsearch" />
                <div v-if="displaylist.length==0" style="width: 100%;height: 100%;position: relative;">
                    <wxl-notify-view>请输入关键词过滤</wxl-notify-view>
                </div>
                <template v-if="displaylist.length>0">
                    <div v-if="ismulpicker==false" class="pick-list-content">
                        <wxl-list-item v-for="t in displaylist" :key="t.id" type="object" class="picker-list-item" :item="t" :righttext="t[memokey]" :showrighttext="memokey!=''"
                            :displaykey="displaykey" @click="clickitem(t)" />
                    </div>
                    <div v-if="ismulpicker==true" class="pick-list-content">
                        <wxl-list-item v-for="t in displaylist" :key="t.id" class="picker-list-item" :refresh="refresh"
                            :text="mulpickertext(t)" :showright="t.checked" @click="onclick(t)" />
                        <div style="display:block;width:100%;height:80px;" />
                    </div>
                    <wxl-list-item class="picker-list-item" textalign="center" textcolor="red" @click="oncancel" />
                    <div class="sure-btn">
                        <wxl-btn v-if="ismulpicker" class="btn" text="反选" @click="invert" />
                        <wxl-btn v-if="ismulpicker" class="btn" text="确定" @click="clickitem" />
                    </div>
                </template>
            </div>
        </div>
    </transition>
</template>
<script>
import linq from 'linq'
import 'animate.css'
import WxlSearchBox from '@/components/Sinour/wxl-search-box.vue'
import wxlNotifyView from '@/components/Sinour/wxl-notify-view.vue'
import WxlListItem from '@/components/Sinour/wxl-list-item.vue'
import WxlBtn from '@/components/Sinour/wxl-btn.vue'
export default {
    components: {
        WxlSearchBox,
        wxlNotifyView,
        WxlListItem,
        WxlBtn
    },
    name: 'wxl-list',
    data() {
        return {
            screenheight: 0,
            screenwidth: 0,
            isios: false,
            displaylist: [],
            disablepy: false,
            cancelonclickmask: true
        }
    },
    methods: {
        onsearch: function(value) {
            var that = this
            var displaylist = linq.from(this.itemsource).where(function(p) {
                if (!p[that.displaykey]) {
                    return true
                }
                if (that.ismulpicker === true) {
                    if (p.checked === true) {
                        return true
                    }
                }
                if (!p.py && that.disablepy === false) {
                    p.py = that.__pyhelper.makePy(p[that.displaykey] + p[that.memokey]).toString().toLowerCase()
                }
                return p[that.displaykey].indexOf(value) > -1 || (p[that.memokey] !== null && p[that.memokey].indexOf(value) > -1) || (p.py && p.py.indexOf(value.toLowerCase()) > -1)
            }).take(100).toArray()
            this.displaylist = displaylist
            if (typeof this.onfilter === 'function') {
                this.onfilter(value, function(list) {
                    that.displaylist = list
                })
            }
        },
        onclick: function(item) {
            item.checked = !item.checked
            this.$forceUpdate()
        },
        onclickmask: function() {
            if (this.cancelonclickmask === true) {
                this.show = false
            }
        },
        invert() {
            for (var i = 0; i < this.displaylist.length; i++) {
                this.displaylist[i].checked = !this.displaylist[i].checked
            }
            this.$forceUpdate()
        },
        mulpickertext(item) {
            if (this.memokey) {
                return item[this.displaykey] + '[' + item[this.memokey] + ']'
            }
            return item[this.displaykey]
        },
        oncancel: function() {
            this.show = false
        }
    },
    mounted: function() {
        this.isios = this.__base.browser.versions.ios
        this.screenheight = document.body.clientHeight
        this.screenwidth = document.body.clientWidth

        this.displaylist = linq.from(this.itemsource).select((p) => {
            p.checked = p.checked ? p.checked : false
            return p
        }).take(100).toArray()
    },
    computed: {
        liststyle() {
            var scale = 1
            if (sessionStorage.getItem('list-scale')) {
                scale = sessionStorage.getItem('list-scale')
            }
            return {
                transform: ` scale(${scale})`
            }
        }
    },
    watch: {
        itemsource() {
            this.displaylist = linq.from(this.itemsource).select((p) => {
                p.checked = p.checked ? p.checked : false
                return p
            }).take(100).toArray()
        }
    }
}
</script>
<style lang="less" scoped>
    @import '@/styles/transition.less';
    @import '@/styles/color.less';
    @import '@/styles/position.less';
    .fixed{
        z-index: 99999999999999999;
        .tran{
            position: relative;
        }
        .animate__animated{
            animation-duration: 500ms;
        }
    }
    .header{
        display: none;
    }
    .picker-list {
        position: absolute;
        left: 0;
        width: 100%;
        top: 0;
        height: 100%;
        background: white;
        overflow-y: scroll;
        -webkit-overflow-scrolling: touch;
        z-index: 999;
    }
    .pick-list-content{
        overflow: scroll;
        top:40px;
        height: calc(100% - 40px);
        position: absolute;
        left: 0;
        width: 100%;
        background: white;
        overflow-y: scroll;
        -webkit-overflow-scrolling: touch;
    }
    .sure-btn{
        position: absolute;
        left: 0;
        bottom: 4px;
        width: 100%;
        .btn{
            display: inline-block;
            width: 50%;
        }
    }
</style>
<style lang="less" scoped>
    // 适配电视屏幕
    @media screen and (min-width:720px) {
        .bgcolor{
            background: rgba(0, 0, 0, 0.3);
        }
        .fixed{
            .header {
                display: block;
                position: relative;
                height: 30px;
                background-color: #007bff;
                color: #fff;
                display: flex;
                flex-direction: row;
                justify-content: space-between;
                align-items: center;

                &::before {
                    content: "";
                    flex: 1;
                }
                .close-tap {
                    margin-right: 4px;
                    display: flex;
                    align-items: center;
                    cursor: pointer;

                    span {
                        font-size: 24px;
                        margin-left: 10px;
                        color: white;
                        text-shadow: 0px 0px 5px rgba(255,255,255,0.5);
                        transition: text-shadow 0.3s, color 0.3s;

                        &:hover {
                            text-shadow: 0px 0px 10px rgba(0, 123, 255, 0.8);
                        }
                    }
                }
            }

            .search-box{
                top: 30px;
            }
            .picker-list{
                left: calc(50% - 240px);
                top: calc(50% - 360px);
                width: 480px;
                height: 720px;
                overflow: hidden;
            }
            .pick-list-content{
                top: 70px;
                overflow-x: hidden;
            }
        }
    }
    // 适配电视屏幕
    @media screen and (max-height:640px) and(min-width: 720px) {
        .bgcolor{
            background: rgba(0, 0, 0, 0.3);
        }
        .fixed{
            .picker-list{
                left: calc(50% - 240px);
                top: calc(50% - 240px);
                width: 360px;
                height: 480px;
                overflow: hidden;
            }
            .pick-list-content{
                overflow-x: hidden;
            }
        }
    }
</style>
